'use client';

import { ReactNode, useEffect } from 'react';
import { motion } from 'motion/react';
import { EASE } from './tokens';

// The first document load shows the SSR HTML as-is (opacity 0 there would hide the page until
// hydration); only client-side navigations, which remount this template, fade in
let hasHydrated = false;

export default function PageFade({ children }: { children: ReactNode }) {
  useEffect(() => {
    hasHydrated = true;
  }, []);

  return (
    <motion.div
      initial={hasHydrated ? { opacity: 0 } : false}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3, ease: EASE.standard }}
    >
      {children}
    </motion.div>
  );
}
